import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  IconButton,
  Checkbox,
  Chip,
  Tooltip,
  Collapse,
  Divider,
  useMediaQuery,
  useTheme,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import {
  fetchParty,
  PartyUpdate,
  deleteParty,
  PartyCreate,
  ApprovePartyapi,
} from "../../../Services/Services";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";

// ✅ Contact Persons Section - COMPONENT KE BAHAR (no re-render issue)
const ContactPersonsSection = ({
  contactPersons = [],
  onAdd,
  onRemove,
  onChange,
}) => (
  <Box sx={{ mt: 2, mb: 2 }}>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1.5,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#555" }}
      >
        Contact Persons
      </Typography>
      <Tooltip title="Add New Contact Person" arrow>
        <IconButton
          size="small"
          onClick={onAdd}
          color="primary"
          sx={{
            border: "1px solid",
            borderColor: "primary.main",
            width: 28,
            height: 28,
            "&:hover": { bgcolor: "primary.main", color: "white" },
          }}
        >
          <AddIcon sx={{ fontSize: "1rem" }} />
        </IconButton>
      </Tooltip>
    </Box>

    {contactPersons.map((person, idx) => (
      <Grid
        container
        spacing={1}
        key={idx}
        sx={{
          mb: 1.5,
          alignItems: "center",
          bgcolor: idx % 2 === 0 ? "#fafafa" : "transparent",
          p: 1,
          borderRadius: 1,
        }}
      >
        {/* ✅ Title/Prefix field with MenuItem */}
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            select
            label="Title"
            fullWidth
            size="small"
            value={person.title || ""}
            onChange={(e) => onChange(idx, "title", e.target.value)}
            SelectProps={{
              MenuProps: {
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                PaperProps: {
                  style: {
                    maxHeight: 200,
                    zIndex: 9999,
                  },
                },
              },
            }}
          >

            <MenuItem value="Mr.">Mr.</MenuItem>
            <MenuItem value="Mrs.">Mrs.</MenuItem>
            <MenuItem value="Ms.">Ms.</MenuItem>
            <MenuItem value="Dr.">Dr.</MenuItem>
            <MenuItem value="Prof.">Prof.</MenuItem>
          </TextField>
        </Grid>

        {/* ✅ Name field */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Name"
            fullWidth
            size="small"
            autoComplete="off"
            value={person.contact_name || ""}
            onChange={(e) => onChange(idx, "contact_name", e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Contact No"
            fullWidth
            size="small"
            autoComplete="off"
            value={person.contact_no || ""}
            onChange={(e) => {
              let value = e.target.value.replace(/[^0-9]/g, "");
              if (value.length > 10) value = value.slice(0, 10);
              onChange(idx, "contact_no", value);
            }}
            inputProps={{ maxLength: 10, inputMode: "numeric" }}
          />
        </Grid>

        <Grid item xs={10} sm={6} md={3}>
          <TextField
            label="Designation"
            fullWidth
            size="small"
            autoComplete="off"
            value={person.designation || ""}
            onChange={(e) => onChange(idx, "designation", e.target.value)}
          />
        </Grid>

        <Grid item xs={2} sm={6} md={1} sx={{ textAlign: "center" }}>
          {contactPersons.length > 1 && (
            <Tooltip title="Remove" arrow>
              <IconButton
                size="small"
                color="error"
                onClick={() => onRemove(idx)}
                sx={{
                  border: "1px solid #ffcdd2",
                  '&:hover': {
                    bgcolor: '#ffebee',
                  }
                }}
              >
                <DeleteIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>
          )}
        </Grid>
      </Grid>
    ))}
  </Box>
);
const PartyManagementTable = () => {
  const [Partys, setPartys] = useState([]);
  const [filter, setFilter] = useState({ name: "" });

  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [openViewModal, setOpenViewModal] = useState(false);
  const [viewParty, setViewParty] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [PartyToDelete, setPartyToDelete] = useState(null);

  const [openApproveRejectModal, setOpenApproveRejectModal] = useState(false);
  const [partyToApprove, setPartyToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [errors, setErrors] = useState({});

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedParty, setExpandedParty] = useState(null);

  // ✅ Empty contact person template
  const getEmptyContactPerson = () => ({
    title: "",
    contact_name: "",
    contact_no: "",
    designation: "",
  });

  const getEmptyFormData = () => ({
    name: "",
    email: "",
    address: "",
    contact: "",
    gst: "",
    pan: "",
    state: "",
    company_name: "",
    contact_persons: [getEmptyContactPerson()], // ✅ NEW
    created_by: localStorage.getItem("user_id"),
  });
  const [formData, setFormData] = useState(getEmptyFormData());

  // ✅ Contact Person Handlers
  const handleAddContactPerson = () => {
    setFormData((prev) => ({
      ...prev,
      contact_persons: [
        ...(prev.contact_persons || []),
        getEmptyContactPerson(),
      ],
    }));
  };

  const handleRemoveContactPerson = (index) => {
    setFormData((prev) => ({
      ...prev,
      contact_persons: prev.contact_persons.filter((_, i) => i !== index),
    }));
  };

  const handleContactPersonChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...(prev.contact_persons || [])];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, contact_persons: updated };
    });
  };

  useEffect(() => {
    fetchPartys(1, false);
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchPartys(1, false);
    }, 500);
    return () => clearTimeout(handler);
  }, [filter.name]);

  const fetchPartys = async (pageNumber = 1, append = false) => {
    try {
      const res = await fetchParty(pageNumber, { name: filter.name });
      const newData = res?.results || res || [];
      if (append) {
        setPartys((prev) => [...prev, ...newData]);
      } else {
        setPartys(newData);
      }
      setHasMore(!!res?.next);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);

  const fetchMoreData = () => {
    if (hasMore) {
      setPage((prevPage) => {
        const nextPage = prevPage + 1;
        fetchPartys(nextPage, true);
        return nextPage;
      });
    }
  };

  const companyExists = (companyName, excludeId = null) => {
    const list = Array.isArray(Partys) ? Partys : [];
    const target = (companyName || "").trim().toLowerCase();
    return list.some(
      (p) =>
        (p?.company_name || "").trim().toLowerCase() === target &&
        (excludeId ? p.id !== excludeId : true)
    );
  };

  const handleAddParty = async () => {
    const requiredFields = ["company_name"];
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        newErrors[field] = "This field is required";
      }
    });

    const formatFields = ["email", "contact", "pan", "gst"];
    formatFields.forEach((field) => {
      const errorMsg = validateField(field, formData[field]);
      if (errorMsg) newErrors[field] = errorMsg;
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (companyExists(formData.company_name)) {
      const msg = "Debtor company already exists";
      toast.info(msg);
      setErrors((prev) => ({ ...prev, company_name: msg }));
      return;
    }

    try {
      // ✅ Filter out empty contact persons
      const cleanedContactPersons = (formData.contact_persons || []).filter(
        (p) =>
          p.contact_name?.trim() ||
          p.contact_no?.trim() ||
          p.designation?.trim()
      );

      await PartyCreate({
        ...formData,
        company_name: formData.company_name.trim(),
        contact_persons: cleanedContactPersons,
      });
      fetchPartys();
      resetForm();
      setOpenAddModal(false);
      toast.success("Debtor created successfully");
    } catch (error) {
      const serverMsg =
        error?.response?.data?.company_name?.[0] ||
        error?.response?.data?.name?.[0] ||
        error?.response?.data?.detail ||
        error?.message;
      if (serverMsg) {
        toast.info(serverMsg);
        setErrors((prev) => ({ ...prev, company_name: serverMsg }));
      } else {
        toast.error("Failed to create Debtor");
      }
    }
  };

  const resetForm = () => {
    setFormData(getEmptyFormData());
    setErrors({});
  };

  const handleDelete = async (party) => {
    try {
      await deleteParty(party.id);
      const updated = Partys.filter((v) => v.id !== party.id);
      setPartys(updated);
      toast.success("Debtor deleted successfully");
    } catch (error) {
      toast.error("Failed to delete Debtor");
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const handleEdit = (party, index) => {
    setFormData({
      ...party,
      contact_persons:
        party.contact_persons?.length > 0
          ? party.contact_persons
          : [getEmptyContactPerson()],
    });
    setPartyToApprove(null);
    setEditIndex(index);
    setOpenEditModal(true);
  };

  const handleViewParty = (party) => {
    setViewParty(party);
    setOpenViewModal(true);
  };

  const validateField = (field, value) => {
    let error = "";
    switch (field) {
      case "email":
        if (value && !/^\S+@\S+\.\S+$/.test(value))
          error = "Invalid email (e.g. name@example.com)";
        break;
      case "contact":
        if (value && !/^\d{10}$/.test(value))
          error = "Invalid phone number (e.g. 9876543210)";
        break;
      case "pan":
        if (value && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value.toUpperCase()))
          error = "Invalid PAN (e.g. ABCDE1234F)";
        break;
      case "gst":
        if (
          value &&
          !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(
            value.toUpperCase()
          )
        )
          error = "Invalid GST (e.g. 27ABCDE1234F1Z5)";
        break;
      default:
        break;
    }
    return error;
  };

  const handleUpdateParty = async (id) => {
    const requiredFields = ["company_name"];
    let newErrors = {};

    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        newErrors[field] = "This field is required";
      }
    });

    const formatFields = ["email", "contact", "pan", "gst"];
    formatFields.forEach((field) => {
      const errorMsg = validateField(field, formData[field]);
      if (errorMsg) newErrors[field] = errorMsg;
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (!id) {
      toast.error("Debtor ID not found");
      return;
    }

    if (companyExists(formData.company_name, id)) {
      const msg = "Debtor company already exists";
      toast.info(msg);
      setErrors((prev) => ({ ...prev, company_name: msg }));
      return;
    }

    try {
      // ✅ Filter empty contact persons
      const cleanedContactPersons = (formData.contact_persons || []).filter(
        (p) =>
          p.contact_name?.trim() ||
          p.contact_no?.trim() ||
          p.designation?.trim()
      );

      const res = await PartyUpdate(id, {
        ...formData,
        company_name: formData.company_name.trim(),
        contact_persons: cleanedContactPersons,
      });
      if (res) {
        toast.success("Debtor updated successfully ✅");
        await fetchPartys();
        setOpenEditModal(false);
        setEditIndex(null);
        setFormData(getEmptyFormData());
        setErrors({});
        setPartyToApprove(null);
      } else {
        toast.error("Failed to update Debtor");
      }
    } catch (error) {
      const serverMsg =
        error?.response?.data?.company_name?.[0] ||
        error?.response?.data?.name?.[0] ||
        error?.response?.data?.detail ||
        error?.message;
      if (serverMsg) {
        toast.info(serverMsg);
        setErrors((prev) => ({ ...prev, company_name: serverMsg }));
      } else {
        toast.error("Error updating Debtor");
      }
    }
  };

  const handleApproveReject = async () => {
    if (!remarkInput.trim()) {
      toast.error("Remark is required!");
      return;
    }

    const approvedById = parseInt(localStorage.getItem("user_id") ?? "", 10);
    if (!Number.isInteger(approvedById)) {
      toast.error("Approver ID invalid or missing");
      return;
    }

    try {
      const partyId = partyToApprove.id;
      const updated = await ApprovePartyapi(
        partyId,
        approvedById,
        actionType,
        remarkInput
      );

      setPartys((prev) =>
        prev.map((item) =>
          item.id === partyId ? { ...item, ...updated } : item
        )
      );

      const msg =
        actionType === "Approved"
          ? "Debtor approved successfully!"
          : "Debtor rejected successfully!";
      toast.success(msg);

      setOpenApproveRejectModal(false);
      setOpenEditModal(false);
      setRemarkInput("");
      setActionType(null);
      setPartyToApprove(null);
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to update debtor approval.");
    }
  };

  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    if (!dateTimeString) return "-";
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    if (format === "dd-mm-yyyy") return `${day}-${month}-${year}`;
    if (format === "yyyy-mm-dd") return `${year}-${month}-${day}`;
    throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
  }

  const userRole = localStorage.getItem("role");

  // Mobile Card Component
  const MobilePartyCard = ({ party, index }) => {
    const isExpanded = expandedParty === party.id;

    return (
      <Box key={party.id}>
        <Box
          onClick={() =>
            setExpandedParty(expandedParty === party.id ? null : party.id)
          }
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 1.5,
            cursor: "pointer",
            bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
            "&:active": { bgcolor: "#e3f2fd" },
            borderLeft: `4px solid ${party.status === "Approved"
                ? "#4caf50"
                : party.status === "Rejected"
                  ? "#f44336"
                  : "#ff9800"
              }`,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
            >
              <Typography
                sx={{ fontSize: "0.7rem", color: "#666", minWidth: 25 }}
              >
                #{index + 1}
              </Typography>
              <Typography
                sx={{ fontWeight: "bold", fontSize: "0.85rem", flex: 1 }}
              >
                {party.company_name}
              </Typography>
            </Box>

            <Typography
              sx={{
                fontSize: "0.75rem",
                color: "#666",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <span style={{ fontWeight: 500 }}>{party.contact}</span>
              <span style={{ color: "#999" }}>•</span>
              <span style={{ fontSize: "0.7rem" }}>
                {truncateText(party.email, 15)}
              </span>
            </Typography>
          </Box>

          <IconButton size="small" sx={{ ml: 1 }}>
            {isExpanded ? (
              <ExpandLess fontSize="small" />
            ) : (
              <ExpandMore fontSize="small" />
            )}
          </IconButton>
        </Box>

        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <Box
            sx={{
              px: 1.5,
              py: 1,
              bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
              borderLeft: `4px solid ${party.status === "Approved"
                  ? "#4caf50"
                  : party.status === "Rejected"
                    ? "#f44336"
                    : "#ff9800"
                }`,
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 0.8,
                mb: 1,
              }}
            >
              <Box></Box>

              <Box>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                  }}
                >
                  GST NO
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    fontWeight: 500,
                    color: "#555",
                  }}
                >
                  {party.gst || "-"}
                </Typography>
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                  }}
                >
                  PAN
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    fontWeight: 500,
                    color: "#555",
                  }}
                >
                  {party.pan || "-"}
                </Typography>
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                  }}
                >
                  CONTACT PERSON
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    fontWeight: 500,
                    color: "#555",
                  }}
                >
                  {party.name || "-"}
                </Typography>
              </Box>
            </Box>

            {party.address && (
              <Box sx={{ mb: 0.8 }}>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                    mb: 0.3,
                  }}
                >
                  ADDRESS
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.7rem",
                    color: "#555",
                    lineHeight: 1.3,
                  }}
                >
                  {party.address}
                </Typography>
              </Box>
            )}

            {party.remarks && (
              <Box sx={{ mb: 0.8 }}>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#999",
                    letterSpacing: "0.5px",
                    mb: 0.3,
                  }}
                >
                  REMARKS
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.7rem",
                    color: "#555",
                    lineHeight: 1.3,
                  }}
                >
                  {party.remarks}
                </Typography>
              </Box>
            )}

            <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Box sx={{ display: "flex", gap: 0.6 }}>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit(party, index);
                  }}
                  sx={{
                    bgcolor:
                      party.status === "Approved" ? "#f5f5f5" : "#e8f5e9",
                    borderRadius: "6px",
                    width: 32,
                    height: 32,
                  }}
                >
                  <EditIcon
                    sx={{
                      fontSize: "1rem",
                      color:
                        party.status === "Approved" ? "#bdbdbd" : "#4caf50",
                    }}
                  />
                </IconButton>

                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setAnchorEl(e.currentTarget);
                    setPartyToDelete(party);
                  }}
                  sx={{
                    bgcolor:
                      party.status === "Approved" ? "#f5f5f5" : "#ffebee",
                    borderRadius: "6px",
                    width: 32,
                    height: 32,
                  }}
                >
                  <DeleteIcon
                    sx={{
                      fontSize: "1rem",
                      color:
                        party.status === "Approved" ? "#bdbdbd" : "#f44336",
                    }}
                  />
                </IconButton>

                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewParty(party);
                  }}
                  sx={{
                    bgcolor: "#e3f2fd",
                    borderRadius: "6px",
                    width: 32,
                    height: 32,
                  }}
                >
                  <VisibilityIcon
                    sx={{ fontSize: "1rem", color: "#1976d2" }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Collapse>

        <Divider />
      </Box>
    );
  };

  return (
    <Box>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      {/* FILTERS BAR */}
      <Box
        sx={{
          pt: 1,
          pb: 1,
          px: 1,
          gap: 1,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          position: "sticky",
          top: 0,
          backgroundColor: "background.paper",
          zIndex: 1100,
          borderBottom: "1px solid #e0e0e0",
          mb: 1,
          mt: { xs: 4, sm: 0 },
        }}
      >
        <TextField
          label="Search by name"
          variant="outlined"
          size="small"
          fullWidth={isMobile}
          value={filter.name || ""}
          onChange={(e) => setFilter({ ...filter, name: e.target.value })}
          sx={{
            flex: 1,
            "& .MuiInputBase-root": { height: 38, borderRadius: 1 },
            "& .MuiInputLabel-root": { fontSize: "0.8rem" },
          }}
        />

        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenAddModal(true)}
          sx={{
            height: 38,
            minWidth: 120,
            display: "flex",
            alignItems: "center",
            fontSize: "0.75rem",
            px: 2,
            borderRadius: 1,
            whiteSpace: "nowrap",
          }}
          startIcon={<AddIcon fontSize="small" />}
        >
          Debtor
        </Button>
      </Box>

      <InfiniteScroll
        dataLength={Partys.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={
          <Typography textAlign="center" p={2}>
            Loading...
          </Typography>
        }
        endMessage={
          <Typography textAlign="center" p={2}>
            No more debtors!
          </Typography>
        }
      >
        {isMobile ? (
          <Box sx={{ bgcolor: "background.paper", pb: 2 }}>
            {Partys.map((party, index) => (
              <MobilePartyCard
                key={party.id}
                party={party}
                index={index}
              />
            ))}
          </Box>
        ) : (
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "88vh", overflow: "auto" }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1900,
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell
                    sx={{
                      position: "sticky",
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                      zIndex: 999,
                      minWidth: 70,
                    }}
                  >
                    S. No.
                  </TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      zIndex: 999,
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                    }}
                  >
                    Company Name
                  </TableCell>
                  <TableCell>Contact Person</TableCell>
                  <TableCell>GST No</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone No</TableCell>
                  <TableCell>PAN</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Approved By</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                      zIndex: 999,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {Partys.map((row, index) => (
                  <TableRow
                    key={index}
                    hover
                    sx={{
                      backgroundColor:
                        index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        "& td": { backgroundColor: "#e3f2fd !important" },
                      },
                      "& td": {
                        padding: "0px",
                        fontSize: "0.7rem",
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        position: "sticky",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark"
                            ? "black"
                            : index % 2 === 0
                              ? "#fafafa"
                              : "#ffffff",
                        zIndex: 998,
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        zIndex: 998,
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark"
                            ? "black"
                            : index % 2 === 0
                              ? "#fafafa"
                              : "#ffffff",
                      }}
                    >
                      <Tooltip title={row.company_name} arrow>
                        <span>{truncateText(row.company_name, 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.gst}</TableCell>
                    <TableCell>
                      <Tooltip title={row.email} arrow>
                        <span>{truncateText(row.email, 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>{row.contact}</TableCell>
                    <TableCell>{row.pan}</TableCell>
                    <TableCell>
                      <Tooltip title={row.address} arrow>
                        <span>{truncateText(row.address, 20)}</span>
                      </Tooltip>
                    </TableCell>

                    <TableCell>
                      {row.authorized_by_name || row.approved_name || "-"}
                    </TableCell>

                    <TableCell>
                      <Tooltip title={row.remarks} arrow>
                        <span>{truncateText(row.remarks, 20)}</span>
                      </Tooltip>
                    </TableCell>

                    <TableCell
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark"
                            ? "black"
                            : index % 2 === 0
                              ? "#fafafa"
                              : "#ffffff",
                        zIndex: 998,
                      }}
                    >
                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        onClick={() => handleEdit(row, index)}
                        color="primary"
                        size="small"
                      >
                        <EditIcon sx={{ fontSize: "1rem" }} />
                      </IconButton>

                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        onClick={(e) => {
                          setAnchorEl(e.currentTarget);
                          setPartyToDelete(row);
                        }}
                        color="error"
                        size="small"
                      >
                        <DeleteIcon sx={{ fontSize: "1rem" }} />
                      </IconButton>

                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        onClick={() => handleViewParty(row)}
                        color="info"
                        size="small"
                      >
                        <VisibilityIcon sx={{ fontSize: "1rem" }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      {/* ========================================== */}
      {/* ✅ ADD PARTY DIALOG                        */}
      {/* ========================================== */}
      <Dialog
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
        maxWidth="md"
        fullWidth
        autoComplete="off"
      >
        <DialogContent>
          <Grid container spacing={2}>
            {/* Row 1: Company Name | Contact Person | Email */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Company Name"
                margin="dense"
                autoComplete="off"
                value={formData.company_name}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormData({ ...formData, company_name: value });
                  const errorMsg = validateField("company_name", value);
                  setErrors((prev) => ({ ...prev, company_name: errorMsg }));
                }}
                required
                error={!!errors.company_name}
                helperText={errors.company_name}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                label="Contact Person"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                label="Email"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.email}
                onChange={(e) => {
                  const value = e.target.value.toLowerCase();
                  setFormData({ ...formData, email: value });
                  const errorMsg = validateField("email", value);
                  setErrors((prev) => ({ ...prev, email: errorMsg }));
                }}
                error={!!errors.email}
                helperText={errors.email}
              />
            </Grid>

            {/* Row 2: Phone | GST | PAN */}
            <Grid item xs={12} md={4}>
              <TextField
                label="Phone No"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.contact}
                onChange={(e) => {
                  let value = e.target.value.replace(/[^0-9]/g, "");
                  if (value.length > 10) value = value.slice(0, 10);
                  setFormData({ ...formData, contact: value });
                  const errorMsg = validateField("contact", value);
                  setErrors((prev) => ({ ...prev, contact: errorMsg }));
                }}
                inputProps={{ maxLength: 10, inputMode: "numeric" }}
                error={!!errors.contact}
                helperText={errors.contact}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                label="GST No"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.gst}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setFormData({ ...formData, gst: value });
                  const errorMsg = validateField("gst", value);
                  setErrors((prev) => ({ ...prev, gst: errorMsg }));
                }}
                inputProps={{ maxLength: 15 }}
                error={!!errors.gst}
                helperText={errors.gst}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                label="PAN No"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.pan}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setFormData({ ...formData, pan: value });
                  const errorMsg = validateField("pan", value);
                  setErrors((prev) => ({ ...prev, pan: errorMsg }));
                }}
                inputProps={{ maxLength: 10 }}
                error={!!errors.pan}
                helperText={errors.pan}
              />
            </Grid>
          </Grid>

          {/* ✅ CONTACT PERSONS SECTION */}
          <ContactPersonsSection
            contactPersons={formData.contact_persons}
            onAdd={handleAddContactPerson}
            onRemove={handleRemoveContactPerson}
            onChange={handleContactPersonChange}
          />

          {/* Address Field */}
          <Grid container sx={{ mb: 1 }}>
            <Grid item xs={12}>
              <TextField
                label="Address"
                autoComplete="off"
                fullWidth
                margin="dense"
                multiline
                rows={1}
                value={formData.address}
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenAddModal(false);
              setFormData(getEmptyFormData());
              resetForm();
            }}
            color="error"
          >
            Close
          </Button>
          <Button onClick={handleAddParty} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>

      {/* ========================================== */}
      {/* VIEW PARTY DIALOG                          */}
      {/* ========================================== */}
      <Dialog
        open={openViewModal}
        onClose={() => {
          setOpenViewModal(false);
          setViewParty(null);
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { maxHeight: "90vh" } }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#1976d2",
            color: "white",
            display: "flex",
            alignItems: "center",
            gap: 1,
            py: 1,
          }}
        >
          <Typography sx={{ fontSize: "0.9rem", fontWeight: "bold" }}>
            Debtor Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {viewParty && (
            <TableContainer
              component={Paper}
              sx={{ maxHeight: "70vh", overflow: "auto", boxShadow: "none" }}
            >
              <Table size="small">
                <TableBody>
                  {[
                    { label: "Company Name", value: viewParty.company_name },
                    { label: "Contact Person", value: viewParty.name },
                    { label: "Email", value: viewParty.email },
                    { label: "Phone No", value: viewParty.contact },
                    { label: "GST No", value: viewParty.gst },
                    { label: "PAN", value: viewParty.pan },
                    { label: "State", value: viewParty.state },
                    { label: "Address", value: viewParty.address, wrap: true },
                    {
                      label: "Status",
                      value: (
                        <Chip
                          label={viewParty.status || "Pending"}
                          color={
                            viewParty.status === "Approved"
                              ? "success"
                              : viewParty.status === "Rejected"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                        />
                      ),
                    },
                    {
                      label: "Created Date",
                      value: viewParty.created_at
                        ? formatOnlyDate(viewParty.created_at)
                        : "-",
                    },
                    {
                      label: "Approved By",
                      value:
                        viewParty.authorized_by_name ||
                        viewParty.approved_name,
                    },
                    {
                      label: "Remarks",
                      value: viewParty.remarks,
                      wrap: true,
                    },
                  ].map((item, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                        "&:hover": { bgcolor: "#e3f2fd" },
                      }}
                    >
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          width: "35%",
                          fontSize: "0.75rem",
                          borderRight: "1px solid #e0e0e0",
                          color: "#333",
                        }}
                      >
                        {item.label}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "0.75rem",
                          whiteSpace: item.wrap ? "normal" : "nowrap",
                          wordBreak: item.wrap ? "break-word" : "normal",
                        }}
                      >
                        {item.value || "-"}
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* ✅ Contact Persons in View Modal */}
                  {viewParty.contact_persons &&
                    viewParty.contact_persons.length > 0 && (
                      <>
                        <TableRow sx={{ bgcolor: "#e3f2fd" }}>
                          <TableCell
                            colSpan={2}
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.8rem",
                              color: "#1976d2",
                            }}
                          >
                            Contact Persons
                          </TableCell>
                        </TableRow>
                        {viewParty.contact_persons.map((cp, idx) => (
                          <TableRow key={idx}>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                fontSize: "0.75rem",
                                color: "#333",
                                borderRight: "1px solid #e0e0e0",
                              }}
                            >
                              Person {idx + 1}
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.75rem" }}>
                              <strong>
                                {cp.title ? `${cp.title} ${cp.contact_name}` : cp.contact_name || "-"}
                              </strong> |{" "}
                              {cp.contact_no || "-"} |{" "}
                              <em>{cp.designation || "-"}</em>
                            </TableCell>
                          </TableRow>

                        ))}
                      </>
                    )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 1.5, bgcolor: "#f5f5f5" }}>
          <Button
            onClick={() => {
              setOpenViewModal(false);
              setViewParty(null);
            }}
            color="primary"
            variant="contained"
            size="small"
            sx={{ fontSize: "0.75rem" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* ========================================== */}
      {/* ✅ EDIT PARTY DIALOG                       */}
      {/* ========================================== */}
      <Dialog
        open={openEditModal}
        onClose={() => {
          setOpenEditModal(false);
          setPartyToApprove(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <Grid container spacing={2} autoComplete="off">
            {/* Row 1: Company Name | Contact Person | Email */}
            <Grid item xs={12} md={4}>
              <TextField
                label="Company Name"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.company_name}
                onChange={(e) =>
                  setFormData({ ...formData, company_name: e.target.value })
                }
                required
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                label="Contact Person"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                label="Email"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.email}
                onChange={(e) => {
                  const value = e.target.value.toLowerCase();
                  setFormData({ ...formData, email: value });
                  const errorMsg = validateField("email", value);
                  setErrors((prev) => ({ ...prev, email: errorMsg }));
                }}
                required
                error={!!errors.email}
                helperText={errors.email}
              />
            </Grid>

            {/* Row 2: Phone | GST | PAN */}
            <Grid item xs={12} md={4}>
              <TextField
                label="Phone No"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.contact}
                onChange={(e) => {
                  let value = e.target.value.replace(/[^0-9]/g, "");
                  if (value.length > 10) value = value.slice(0, 10);
                  setFormData({ ...formData, contact: value });
                  const errorMsg = validateField("contact", value);
                  setErrors((prev) => ({ ...prev, contact: errorMsg }));
                }}
                inputProps={{ maxLength: 10, inputMode: "numeric" }}
                required
                error={!!errors.contact}
                helperText={errors.contact}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                label="GST No"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.gst}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setFormData({ ...formData, gst: value });
                  const errorMsg = validateField("gst", value);
                  setErrors((prev) => ({ ...prev, gst: errorMsg }));
                }}
                inputProps={{ maxLength: 15 }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                label="PAN No"
                fullWidth
                margin="dense"
                autoComplete="off"
                value={formData.pan}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setFormData({ ...formData, pan: value });
                  const errorMsg = validateField("pan", value);
                  setErrors((prev) => ({ ...prev, pan: errorMsg }));
                }}
                inputProps={{ maxLength: 10 }}
              />
            </Grid>
          </Grid>

          {/* ✅ CONTACT PERSONS SECTION */}
          <ContactPersonsSection
            contactPersons={formData.contact_persons}
            onAdd={handleAddContactPerson}
            onRemove={handleRemoveContactPerson}
            onChange={handleContactPersonChange}
          />

          {/* Address Field */}
          <Grid container sx={{ mb: 1 }}>
            <Grid item xs={12}>
              <TextField
                label="Address"
                fullWidth
                autoComplete="off"
                margin="dense"
                multiline
                rows={2}
                value={formData.address}
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          {partyToApprove && userRole != "Staff" && (
            <>
              <Button
                color="success"
                size="small"
                onClick={() => {
                  setActionType("Approved");
                  setOpenApproveRejectModal(true);
                }}
              >
                Approve
              </Button>

              <Button
                sx={{ color: "orange" }}
                size="small"
                onClick={() => {
                  setActionType("Rejected");
                  setOpenApproveRejectModal(true);
                }}
              >
                Reject
              </Button>
            </>
          )}

          <Button
            onClick={() => handleUpdateParty(formData.id)}
            color="primary"
          >
            Save
          </Button>

          <Button
            onClick={() => {
              setOpenEditModal(false);
              setFormData(getEmptyFormData());
              setPartyToApprove(null);
            }}
            color="error"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Approve/Reject Modal */}
      <Dialog
        open={openApproveRejectModal}
        onClose={() => {
          setOpenApproveRejectModal(false);
          setRemarkInput("");
          setActionType(null);
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          {actionType === "Approved" ? "Approve Debtor" : "Reject Debtor"}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Please enter a remark before{" "}
            {actionType === "Approved" ? "approving" : "rejecting"} this
            debtor:
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            value={remarkInput}
            onChange={(e) => setRemarkInput(e.target.value)}
            placeholder="Enter remark..."
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenApproveRejectModal(false);
              setRemarkInput("");
              setActionType(null);
            }}
          >
            Cancel
          </Button>
          <Button
            color={actionType === "Approved" ? "success" : "error"}
            variant="contained"
            onClick={handleApproveReject}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Popover */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setPartyToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box sx={{ p: 2, maxWidth: 220 }}>
          <Typography variant="body2" gutterBottom>
            Are you sure you want to delete{" "}
            <strong>{PartyToDelete?.company_name}</strong>?
          </Typography>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
          >
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setPartyToDelete(null);
              }}
            >
              Close
            </Button>
            <Button
              size="small"
              color="error"
              onClick={async () => {
                await handleDelete(PartyToDelete);
                setAnchorEl(null);
                setPartyToDelete(null);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default PartyManagementTable;